import { Directive, TemplateRef } from "@angular/core";

export interface OptionLayoutContext<Model> {
  $implicit: Model;
  model: Model;
}

@Directive({
  selector: "[taOptionLayout]"
})
export class OptionLayoutDirective<Model> {
  constructor(public templateRef: TemplateRef<OptionLayoutContext<Model>>) {}
}

@Directive({
  selector: "[taSelectedOptionLayout]"
})
export class SelectedOptionLayoutDirective<Model> extends OptionLayoutDirective<
  Model
> {
  constructor(templateRef: TemplateRef<OptionLayoutContext<Model>>) {
    super(templateRef);
  }
}

@Directive({
  selector: "[taNewOptionLayout]"
})
export class NewOptionLayoutDirective<Model> extends OptionLayoutDirective<Model> {
  constructor(templateRef: TemplateRef<OptionLayoutContext<Model>>) {
    super(templateRef);
  }
}
